import { render, staticRenderFns } from "./ArenaSignEditTemplateAfterSignMappings.vue?vue&type=template&id=65f05e8b&"
import script from "./ArenaSignEditTemplateAfterSignMappings.vue?vue&type=script&lang=ts&"
export * from "./ArenaSignEditTemplateAfterSignMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports